import { Subject } from 'rxjs';

const subject = new Subject<boolean>();

export const FinalVideoService = {
    sendFinal: (res: boolean) => subject.next(res),
    getFinal: () => subject.asObservable()
};